import { useQueryParams, useQueryParam, StringParam, NumberParam, ArrayParam } from "use-query-params";
const parseNestedObject = (fieldQueryString) => {
  try {
    return JSON.parse(decodeURIComponent(fieldQueryString));
  } catch (_error) {
    return void 0;
  }
};
const NestedObjectParam = {
  encode: (object) => encodeURIComponent(JSON.stringify(object)),
  decode: (objectStr) => parseNestedObject(objectStr)
};
export { useQueryParams, useQueryParam, StringParam, NumberParam, NestedObjectParam, ArrayParam };
